// From Vssf/WebPlatform/Platform/Scripts/VSS/Utils/UI.ts
/// <amd-module name="Wit/Settings/BoardsExternalIntegration/utils/BrowserUtil" />

let _isIE: boolean | undefined;
export function isIE() {
    if (_isIE === undefined) {
        const userAgent = navigator.userAgent.toLowerCase();
        const msie = /msie ([\d+.]+)/i.exec(userAgent);
        if (msie) {
            // IE10 and earlier
            _isIE = true;
        } else {
            // IE11 deliberately removed 'msie'
            _isIE = userAgent.indexOf("trident") !== -1;
        }
    }
    return _isIE;
}
